// Zentrale Deeplink-Helfer für Entity-Detailansichten. Wird genutzt von
// Plausi-Warnungen, Belegprüfung etc. Pfad-Änderungen nur hier pflegen.

// FL-App: Ausgabe-Detail (Finanzen-Seite verarbeitet ?openExpense=<id>).
export const expenseDetailUrl = (id) => `/finances?openExpense=${id}`;

// FL-App: Rechnungs-Detail (Rechnungen-Seite verarbeitet ?openInvoice=<id>).
export const invoiceDetailUrl = (id) => `/invoices?openInvoice=${id}`;

// FL-App: generischer Deeplink für eine Entity (invoice|expense).
export const entityDetailUrl = (entityType, id) =>
  entityType === 'expense' ? expenseDetailUrl(id) : invoiceDetailUrl(id);

// SB-Portal: Mandanten-Detail mit Fokus auf eine Entity (öffnet Drawer).
export const advisorFocusUrl = (clientId, entityType, entityId, year) =>
  `/advisor/client/${clientId}?focus=${entityType}:${entityId}${year ? `&year=${year}` : ''}`;
